import { useState } from "react";
import { useNavigate } from "react-router";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

const CustomerAction = ({ row, authState, handleStatusChange, handlestatusArchive }) => {
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleEditClick = () => {
        const editFormURL = `${process.env.PUBLIC_URL}/customers/customer-edit?id=${row.id}`;
        navigate(editFormURL);
    };

    const handlestatusinactive = (id) => {
        handleStatusChange(id, 'inactive', 'Deactivate');
    };

    const handlestatusSuspend = (id) => {
        handleStatusChange(id, 'suspended', 'Suspend');
    };

    const handlestatusactivate = (id) => {
        handleStatusChange(id, 'active', 'Activate');
    };

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ fontSize: '15px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    {row.Status !== "archive" && (authState.userRole === 1 || authState.permissions.includes('edit-customer')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handleEditClick()}>Edit</DropdownItem>
                    )}
                    {row.Status !== "active" && row.Status !== "archive" && (
                        <DropdownItem style={toggleStyle} onClick={() => handlestatusactivate(row.id)}>Activate</DropdownItem>
                    )}
                    {row.Status !== "inactive" && row.Status !== "suspended" && row.Status !== "archive" && (authState.userRole === 1 || authState.permissions.includes('customer-deactivate')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handlestatusinactive(row.id)}>Deactivate</DropdownItem>
                    )}
                    {row.Status !== "suspended" && row.Status !== "archive" && (authState.userRole === 1 || authState.permissions.includes('customer-suspend')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handlestatusSuspend(row.id)}>Suspend</DropdownItem>
                    )}
                    {row.Status !== "archive" && (authState.userRole === 1 || authState.permissions.includes('remove-customer')) && (
                        <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px', margin: '0' }} onClick={() => handlestatusArchive(row.id, row)}>Archive</DropdownItem>
                    )}
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};

export default CustomerAction;